import React, { useContext, useState } from 'react';
import { IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import CloudDownloadOutlinedIcon from '@material-ui/icons/CloudDownloadOutlined';
import moment from 'moment';
import { ToastMessageContext } from 'lib/contexts/message_context';

export default function DownloadCsv({
    startDate = null,
    endDate = null,
    isDateFilterPresent = false,
    onDownload,
    tooltip = 'Download CSV',
    format,
    marginTop,
    position = "relative",
    marginLeft
}) {

    const message = useContext(ToastMessageContext);
    const [disabled, setDisabled] = useState(false);

    const handleDownload = () => {
        if (disabled) return;

        if (isDateFilterPresent) {
            if (!startDate || !endDate) {
                message.showToastMessage({
                    message: 'Date filter must be applied',
                    variant: 'error',
                });
                return;
            }

            const start = moment(startDate, format ?? 'DD/MM/YYYY', true);
            const end = moment(endDate, format ?? 'DD/MM/YYYY', true);

            if (!start.isValid() || !end.isValid()) {
                message.showToastMessage({
                    message: 'Invalid date format',
                    variant: 'error',
                });
                return;
            }

            const diffDays = end.diff(start, 'days');

            if (diffDays > 365) {
                message.showToastMessage({
                    message: 'Date range cannot exceed 1 year',
                    variant: 'error',
                });
                return;
            }

            if (diffDays < 0) {
                message.showToastMessage({
                    message: 'End date must be after start date',
                    variant: 'error',
                });
                return;
            }
        }

        onDownload();
        setDisabled(true);

        setTimeout(() => {
            setDisabled(false);
        }, 2000);
    };

    return (
        <Tooltip title={disabled ? 'File is downloading…' : tooltip}>

            <IconButton
                onClick={handleDownload}
                disabled={disabled}
                style={{
                    position: position ?? 'relative',
                    marginTop: marginTop ?? '-71px',
                    marginLeft: marginLeft ?? '10px'
                }}
            >
                <CloudDownloadOutlinedIcon color={"secondary"} htmlColor={disabled && "#4D4F5C"} />
            </IconButton>


        </Tooltip>
    );
}
